import React from 'react'
import Translate from '../general/translate'

const Affiliatesection = () => {

  return(
    <div className="pb-6 bg-[#643ADA]" id="affiliatesection">
      <div className="mx-auto grid grid-cols-12 grid-flow-col  pb-5 pt-10">
        <div className="col-span-10 col-start-2 text-center lg:text-left flex flex-col p-10 py-20 items-center rounded-3xl bg-[#27004f]">
          <h3 className="text-center text-md leading-tight font-extrabold text-white opacity-60 tracking-wide mb-8">
            <Translate id="affiliate.section.title" foldername="general" filename="affiliatesection" />
          </h3>
          <h2 className="text-center leading-tight text-3xl lg:text-5xl text-[#F3F3F1] font-bold mb-10">
            <Translate id="affiliate.section.subtitle" foldername="general" filename="affiliatesection" />
            <span className="text-[#FFCA1D] font-extrabold"> <Translate id="affiliate.section.earn" foldername="general" filename="affiliatesection" /></span>
          </h2>
           <img src="/affiliates/affiliategraphics.webp" alt="Podsqueeze onboarding ebook" className="sm:h-[88px] w-auto my-10"/>
           <p className="text-xl mb-5 text-center text-[#B8AEC3] lg:px-20 mt-10">
             <Translate id="affiliate.section.commission" foldername="general" filename="affiliatesection" />
           </p>
           <p className="text-xl mb-5 text-center text-[#B8AEC3] lg:px-20">
             <Translate id="affiliate.section.join" foldername="general" filename="affiliatesection" />
           </p>   
           <a href="/affiliates" className="inline-block bg-[#FFCA1D] text-[#483187] mt-10 font-bold text-xl px-8 py-4 rounded-[8px] shadow hover:shadow-lg no-underline focus:no-underline text-center m-auto">
             <Translate id="affiliate.section.knowMore" foldername="general" filename="affiliatesection" />
           </a>            
        </div>
      </div>
    </div>
  )
}

export default Affiliatesection